function escapeCSVValue(value) {
  if (value == null) return '';
  const str = String(value);
  if (/[",\n]/.test(str)) {
    // Escape double quotes by doubling them
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

function DownloadCSV(filename, data) {
    const header = Object.keys(data?.[0] || {}).map(escapeCSVValue).join(",");
    const values = data.map((item) =>
      Object.values(item).map(escapeCSVValue).join(",")
    );
    const csvFile = [header, ...values].join("\n");

    var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

export default DownloadCSV;